import "core-js/modules/es.array.push.js";
import VDebug from './VDebug.vue';
import VDesc from './VDesc.vue';
import VShow from './VShow.vue';
import { getInterfaceDetail, interfaceDebug } from '@/api/modules/personal.js';
import { urlParamsColumns } from './column.js';
export default {
  components: {
    VDebug,
    VDesc,
    VShow
  },
  props: {
    _id: String
  },
  data() {
    return {
      urlParamsColumns,
      pageLoading: false,
      interfaceDetail: {},
      debugParamsArr: [],
      // 所有调试参数组成的数组（包括勾选和没勾选的）
      debugResponseJSON: {},
      // 调试返回的JSON数据
      debugLoading: false,
      activeKey: '1',
      activeTitle: 'titleRef1',
      // 激活的接口介绍的title
      details: {
        name: '自然语言查询股票，判断是否为交易日',
        desc: '接口简短说明，内容不超过200字，接口简短说明，内容不超过200字，接口简短说明，内容不超过200字，接口简短说明，内容不超过200字',
        request: {
          mode: 'GET',
          codeWay: 'UTF-8',
          backWay: 'JSON'
        }
      },
      form: this.$form.createForm(this, {
        name: 'coordinated'
      }),
      leftTitleList: [],
      // 接口介绍页面标题
      titleList: [{
        key: 'titleRef1',
        title: '接口说明',
        name: 'detailed_description'
      }, {
        key: 'titleRef2',
        title: '应用场景',
        name: 'scene'
      }, {
        key: 'titleRef3',
        title: '请求头部',
        name: 'interface_header_info'
      }, {
        key: 'titleRef4',
        title: '请求参数',
        name: 'interface_request_info'
      }, {
        key: 'titleRef5',
        title: '返回参数',
        name: 'interface_result_info'
      }, {
        key: 'titleRef6',
        title: '返回状态码',
        name: 'interface_code_info'
      }, {
        key: 'titleRef7',
        title: '成功示例',
        name: 'success_mock'
      }
      // {
      //   key: 'titleRef8',
      //   title: '失败示例'
      // },
      ]
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: [],
        // 勾选的参数，可以通过this.rowSelection.selectedRowKeys读取
        onChange: selectedRowKeys => {
          this.rowSelection.selectedRowKeys.splice(0);
          Object.assign(this.rowSelection.selectedRowKeys, selectedRowKeys);
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.param_not_null === '是',
            name: record.param_key
          }
        })
      };
    }
  },
  methods: {
    changeTitle(item) {
      this.activeTitle = item.key;
      const el = document.getElementById(item.key);
      // console.log(el.offsetTop);
      document.documentElement.scrollTop = el.offsetTop;
    },
    hasKey(obj) {
      if (obj === null) {
        return false;
      }
      return Object.keys(JSON.parse(obj)).length > 0;
    },
    toInput(data) {
      this.debugParamsArr.forEach(item => {
        if (item.param_key === data.param_key && item.param_not_null === '是') {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              [item.param_key]: item.param_range
            });
          });
        }
      });
    },
    // 判断当前表单是否必填,配置表单
    getTooltip(data) {
      if (data.param_not_null === '是') {
        return [data.param_key, {
          rules: [{
            required: true,
            message: '请输入!'
          }]
        }];
      }
      return [data.param_key, {
        rules: []
      }];
    },
    // 加入接口意向单
    addOrderList() {
      this.$emit('addOrderList', {
        product_code: this._id,
        product_type: 3
      });
    },
    // 获取指定接口的详情信息
    getInterfaceInfo() {
      getInterfaceDetail({
        _id: this._id
      }).then(res => {
        if (res.code === 1) {
          var _this$interfaceDetail;
          this.pageLoading = false;
          this.interfaceDetail = {
            ...res.result,
            interface_header_info: this.hasKey(res.result.interface_header_info) ? JSON.parse(res.result.interface_header_info) : [],
            // 请求头部
            interface_request_info: this.hasKey(res.result.interface_request_info) ? JSON.parse(res.result.interface_request_info) : [],
            // 请求参数
            interface_result_info: this.hasKey(res.result.interface_result_info) ? JSON.parse(res.result.interface_result_info) : [],
            // 返回参数
            interface_code_info: this.hasKey(res.result.interface_code_info) ? JSON.parse(res.result.interface_code_info) : [],
            // 返回状态码
            success_mock: this.hasKey(res.result.interface_return_info) ? JSON.parse(res.result.interface_return_info).success_mock : {} // 成功结果示例
          };
          // Object.assign(, obj);
          // 初始化调试参数数组
          (_this$interfaceDetail = this.interfaceDetail.interface_request_info) === null || _this$interfaceDetail === void 0 || _this$interfaceDetail.forEach(item => {
            const {
              param_key,
              param_not_null,
              param_range
            } = item;
            this.debugParamsArr.push(item);
            if (param_not_null === '是') {
              // 必选的参数默认选中，并且禁止再点击
              this.rowSelection.selectedRowKeys.push(param_key);
            }

            // 默认值
            if (param_range) {
              this.$nextTick(() => {
                this.form.setFieldsValue({
                  [param_key]: param_range
                });
              });
            }
          });
        }
        this.handlerTitle(this.interfaceDetail);
      });
    },
    // 无数据模块不展示标题
    handlerTitle(data) {
      this.leftTitleList = [];
      this.titleList.forEach((item, index) => {
        var _data$item$name;
        if (((_data$item$name = data[item.name]) === null || _data$item$name === void 0 ? void 0 : _data$item$name.length) !== 0 && (data[item.name] !== '[]' || data[item.name] !== '{}')) {
          this.leftTitleList.push(item);
        }
      });
    },
    // 发送请求
    sendRequestEvent() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.activeKey = '2';
          this.sendRequest(values);
        } else {
          return;
        }
      });
    },
    // 发送调试请求
    sendRequest(data) {
      this.debugResponseJSON = {};
      this.debugLoading = true;
      interfaceDebug({
        _id: this._id,
        interface_request_method: this.interfaceDetail.interface_request_method,
        param: data
      }).then(res => {
        this.debugLoading = false;
        if (res.code === 1) {
          this.debugResponseJSON = res.result;
        }
      });
    },
    scrollTitle(v) {
      this.activeTitle = v;
    }
  },
  watch: {
    _id: {
      handler(val) {
        if (val) {
          this.pageLoading = true;
          this.activeKey = '1';
          this.debugResponseJSON = {};
          this.debugParamsArr.splice(0);
          this.getInterfaceInfo();
        }
      },
      immediate: true
    }
  }
};